export const ROLES = [
    'model',
    'artist',
    'dancer',
    'singer',
    'presenter',
    'light',
    'sound',
    'dj',
    'director',
    'photographer'
];